export enum NotificationHubMethod {
  NEW_NOTIFICATION = 'new-notification',
  NEW_BACKGROUND_TASK = 'new-background-task',
  UPDATE_BACKGROUND_TASK = 'update-background-task',
  FINISH_BACKGROUND_TASK = 'finish-background-task',
}
